import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=a5da5e2a&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=a5da5e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5da5e2a",
  null
  
)

export default component.exports